/* Lumora theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  const pad = (n) => String(n).padStart(2, '0');

  /* ------------------------------------------------------------
     Drawers (menu, cart, search) + overlay
  ------------------------------------------------------------ */
  const overlay = () => $('[data-overlay]');
  let lastFocus = null;

  function openDrawer(id) {
    const el = document.getElementById(id);
    if (!el) return;
    closeAll();
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-open'));
    if (overlay()) overlay().hidden = false;
    document.body.classList.add('no-scroll');
    const focusable = el.querySelector('input[type="search"], button, a[href], input');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeAll() {
    $$('.drawer.is-open, .search-modal:not([hidden])').forEach((el) => {
      el.classList.remove('is-open');
      if (el.classList.contains('search-modal')) el.hidden = true;
    });
    if (overlay()) overlay().hidden = true;
    document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const id = opener.getAttribute('data-open');
      if (id === 'cart-drawer' && window.theme.cartType !== 'drawer') return;
      if (document.getElementById(id)) { e.preventDefault(); openDrawer(id); }
      return;
    }
    if (e.target.closest('[data-close]') || e.target.matches('[data-overlay]')) {
      e.preventDefault();
      closeAll();
      if (lastFocus) lastFocus.focus();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ------------------------------------------------------------
     Cart (AJAX + Section Rendering API)
  ------------------------------------------------------------ */
  const CART_SECTIONS = ['cart-drawer', 'cart-icon'];

  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = html.querySelector('#CartDrawerInner');
      const current = document.getElementById('CartDrawerInner');
      if (fresh && current) current.replaceWith(fresh);
      initCartTimer();
      setTimeout(syncDrawerExtras, 0);
    }
    if (sections['cart-icon']) {
      const html = new DOMParser().parseFromString(sections['cart-icon'], 'text/html');
      const fresh = html.querySelector('[data-cart-count]');
      $$('[data-cart-count]').forEach((el) => { el.outerHTML = fresh ? fresh.outerHTML : ''; });
    }
  }

  function showError(container, msg) {
    let box = container && container.querySelector('.product-form__error');
    if (!box && container) {
      box = document.createElement('p');
      box.className = 'product-form__error';
      box.setAttribute('role', 'alert');
      container.appendChild(box);
    }
    if (box) { box.textContent = msg; box.hidden = !msg; }
  }

  async function addToCart(form, submitter) {
    const btn = submitter || form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    showError(form, '');
    try {
      const fd = new FormData(form);
      const items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }];
      const props = {};
      for (const [k, v] of fd.entries()) {
        const m = k.match(/^properties\[(.+)\]$/);
        if (m && v) props[m[1]] = v;
      }
      if (Object.keys(props).length) items[0].properties = props;
      if (fd.get('selling_plan')) items[0].selling_plan = Number(fd.get('selling_plan'));

      const scope = form.closest('[data-product-info]') || form;
      $$('[data-upsell]:checked', scope).forEach((cb) => items.push({ id: Number(cb.value), quantity: 1 }));

      const sections = window.theme.cartType === 'drawer' && !(submitter && submitter.name === 'buy_now') ? CART_SECTIONS : [];
      const res = await fetch(window.theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || window.theme.strings.error);

      if (submitter && submitter.name === 'buy_now') { window.location.href = window.theme.routes.root.replace(/\/$/, '') + '/checkout'; return; }
      if (window.theme.cartType !== 'drawer') { window.location.href = window.theme.routes.cart; return; }
      renderSections(data.sections);
      openDrawer('cart-drawer');
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      showError(form, err.message);
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('[data-ajax-cart], .js-product-form')) {
      e.preventDefault();
      addToCart(form, e.submitter);
    }
  });

  async function changeLine(key, quantity) {
    const drawer = document.getElementById('cart-drawer');
    const onPage = document.body.classList.contains('template-cart');
    if (drawer) drawer.classList.add('is-busy');
    try {
      const res = await fetch(window.theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: CART_SECTIONS, sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (onPage) { window.location.reload(); return; }
      renderSections(data.sections);
    } catch (err) {
      window.location.reload();
    } finally {
      if (drawer) drawer.classList.remove('is-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.dataset.key, Number(btn.dataset.qty));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (input) changeLine(input.dataset.key, Math.max(0, Number(input.value)));
  });

  /* Cart note (debounced) */
  let noteTimer;
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-cart-note]')) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => {
      fetch(window.theme.routes.cart + '/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: e.target.value })
      });
    }, 400);
  });

  /* Cart reservation timer */
  function initCartTimer() {
    const el = $('[data-cart-timer]');
    if (!el) return;
    const out = el.querySelector('[data-timer]');
    const minutes = Number(el.dataset.minutes || window.theme.timerMinutes || 10);
    let end = Number(store.get('lumora-cart-timer'));
    if (!end || end < Date.now()) {
      end = Date.now() + minutes * 60000;
      store.set('lumora-cart-timer', end);
    }
    clearInterval(window.__cartTimer);
    const tick = () => {
      let left = Math.max(0, end - Date.now());
      if (left === 0) {
        end = Date.now() + minutes * 60000;
        store.set('lumora-cart-timer', end);
        left = end - Date.now();
      }
      const m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      if (out) out.textContent = pad(m) + ':' + pad(s);
    };
    tick();
    window.__cartTimer = setInterval(tick, 1000);
  }


  /* ------------------------------------------------------------
     Cart drawer extras: upsells, preselected upsells, gift, discount, terms
  ------------------------------------------------------------ */
  let drawerBusy = false;
  async function cartPost(url, body) {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.classList.add('is-busy');
    drawerBusy = true;
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({ sections: CART_SECTIONS, sections_url: window.location.pathname }, body))
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Cart error');
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return data; }
      drawerBusy = false;
      renderSections(data.sections);
      return data;
    } finally {
      drawerBusy = false;
      if (drawer) drawer.classList.remove('is-busy');
    }
  }
  const addItems = (items) => cartPost(window.theme.routes.cartAdd + '.js', { items });
  const setLine = (key, quantity) => cartPost(window.theme.routes.cartChange + '.js', { id: key, quantity });

  // Upsell toggles (switch, checkbox or add button)
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-upsell-toggle]');
    if (!input) return;
    const row = input.closest('.upsell');
    if (row) row.classList.add('is-busy');
    const variantSel = row && row.querySelector('[data-upsell-variant]');
    const variantId = Number(variantSel ? variantSel.value : input.value);
    try {
      if (input.checked) {
        store.set('lumora-upsell-declined-' + input.value, '');
        await addItems([{ id: variantId, quantity: 1 }]);
      } else if (input.dataset.key) {
        store.set('lumora-upsell-declined-' + input.value, '1');
        await setLine(input.dataset.key, 0);
      }
    } catch (err) {
      input.checked = !input.checked;
      if (row) row.classList.remove('is-busy');
    }
  });
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-upsell-variant]');
    if (!sel) return;
    const input = sel.closest('.upsell').querySelector('[data-upsell-toggle]');
    if (input) input.value = sel.value;
  });

  // Preselected upsells + conditional gift, run after every drawer render
  async function syncDrawerExtras() {
    if (drawerBusy) return;
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawer.querySelector('.cd-items, .cart-item')) return;

    const toAdd = [];
    $$('[data-upsell-toggle][data-preselected="true"]', drawer).forEach((input) => {
      if (input.checked) return;
      const id = input.value;
      if (store.get('lumora-upsell-declined-' + id) === '1') return;
      if (store.get('lumora-upsell-auto-' + id) === '1') return;
      store.set('lumora-upsell-auto-' + id, '1');
      toAdd.push({ id: Number(id), quantity: 1 });
    });

    const gift = drawer.querySelector('[data-gift]');
    if (gift) {
      const unlocked = gift.dataset.unlocked === 'true';
      const key = gift.dataset.key;
      if (unlocked && !key) toAdd.push({ id: Number(gift.dataset.variant), quantity: 1 });
      else if (!unlocked && key) { try { await setLine(key, 0); } catch (err) {} return; }
      else if (unlocked && key && Number(gift.dataset.qty) > 1) { try { await setLine(key, 1); } catch (err) {} return; }
    }
    if (toAdd.length) { try { await addItems(toAdd); } catch (err) {} }
  }

  // Discount codes
  async function applyDiscount(codes) {
    const drawer = document.getElementById('cart-drawer');
    const res = await fetch(window.theme.routes.cart + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: CART_SECTIONS, sections_url: window.location.pathname })
    });
    const data = await res.json();
    renderSections(data.sections);
    return data;
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('input[name="discount"]');
    const code = (input.value || '').trim();
    const err = form.parentElement.querySelector('[data-discount-error]');
    if (!code) { if (err) err.hidden = false; return; }
    const existing = $$('[data-discount-remove]', form.parentElement).map((b) => b.dataset.discountRemove);
    try {
      const data = await applyDiscount(existing.concat(code));
      const applied = (data.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      const fresh = document.querySelector('[data-discount-error]');
      if (fresh) fresh.hidden = !!(applied && applied.applicable);
    } catch (ex) { if (err) err.hidden = false; }
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-discount-remove]');
    if (!b) return;
    const remaining = $$('[data-discount-remove]').map((x) => x.dataset.discountRemove).filter((c) => c !== b.dataset.discountRemove);
    applyDiscount(remaining);
  });

  // Terms checkbox blocks checkout until ticked
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-checkout-form]');
    if (!form) return;
    const scope = form.closest('#cart-drawer') || document;
    const tnc = scope.querySelector('[data-tnc]');
    if (tnc && !tnc.checked) {
      e.preventDefault();
      const w = scope.querySelector('[data-tnc-warning]');
      if (w) w.hidden = false;
    }
  }, true);
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-tnc]')) return;
    const w = (e.target.closest('#cart-drawer') || document).querySelector('[data-tnc-warning]');
    if (w && e.target.checked) w.hidden = true;
  });

  /* ------------------------------------------------------------
     Quantity steppers
  ------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.closest('.qty').querySelector('input');
    const step = Number(b.dataset.qtyStep);
    const min = Number(input.min || 1);
    input.value = Math.max(min, Number(input.value || min) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------
     Product page: variants, gallery, sticky ATC
  ------------------------------------------------------------ */
  function initProduct(root) {
    const sectionId = root.dataset.section;
    const url = root.dataset.url;
    const dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const form = root.querySelector('form.js-product-form');
    const idInput = form && form.querySelector('input[name="id"]');

    const currentOptions = () => {
      return $$('[data-option-index]', root)
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
        .map((g) => {
          const checked = g.querySelector('input:checked');
          const sel = g.querySelector('select');
          return checked ? checked.value : sel ? sel.value : null;
        });
    };

    const markAvailability = (opts) => {
      $$('[data-option-index]', root).forEach((g) => {
        const idx = Number(g.dataset.optionIndex);
        g.querySelectorAll('input[type="radio"]').forEach((inp) => {
          const ok = variants.some((v) => v.available && v.options[idx] === inp.value &&
            v.options.every((o, i) => i >= idx || o === opts[i]));
          inp.classList.toggle('is-unavailable', !ok);
        });
        const label = g.querySelector('[data-selected-value]');
        if (label) label.textContent = opts[idx];
      });
    };

    let controller;
    const onChange = async () => {
      const opts = currentOptions();
      markAvailability(opts);
      const variant = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      const btns = $$('[data-atc]', root.ownerDocument);
      if (!variant) {
        btns.forEach((b) => { b.disabled = true; const l = b.querySelector('.btn__label'); if (l) l.textContent = window.theme.strings.unavailable; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      $$('input[name="id"][data-sync]', document).forEach((i) => (i.value = variant.id));
      window.history.replaceState({}, '', url + '?variant=' + variant.id);

      if (variant.featured_media) goToMedia(root, variant.featured_media.id);

      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const res = await fetch(url + '?variant=' + variant.id + '&section_id=' + sectionId, { signal: controller.signal });
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        $$('[data-update]', html).forEach((fresh) => {
          const key = fresh.dataset.update;
          $$('[data-update="' + key + '"]').forEach((cur) => { cur.innerHTML = fresh.innerHTML; cur.hidden = fresh.hidden; });
        });
        document.dispatchEvent(new CustomEvent('product:updated'));
        btns.forEach((b) => {
          b.disabled = !variant.available;
          const l = b.querySelector('.btn__label');
          if (l) l.textContent = variant.available ? (b.dataset.label || window.theme.strings.addToCart) : window.theme.strings.soldOut;
        });
      } catch (e) { /* aborted */ }
    };
    root.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) onChange(); });
    markAvailability(currentOptions());

    /* Gallery */
    const track = root.querySelector('.gallery__track');
    if (track) {
      const slides = $$('.gallery__slide', track);
      const thumbs = $$('.gallery__thumb', root);
      const setActive = (i) => thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
      thumbs.forEach((t, i) => t.addEventListener('click', () => {
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i);
      }));
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(i);
      }, { passive: true });
      root.querySelectorAll('[data-gallery-nav]').forEach((b) => b.addEventListener('click', () => {
        const dir = Number(b.dataset.galleryNav);
        const i = Math.round(track.scrollLeft / track.clientWidth) + dir;
        const n = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[n].offsetLeft, behavior: 'smooth' });
      }));
    }

    /* Sticky add to cart */
    const sticky = document.querySelector('[data-sticky-atc="' + sectionId + '"]');
    const mainBtn = root.querySelector('[data-main-atc]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
      }).observe(mainBtn);
      sticky.addEventListener('click', (e) => {
        const b = e.target.closest('[data-sticky-action]');
        if (!b) return;
        e.preventDefault();
        if (form && form.requestSubmit) form.requestSubmit(mainBtn);
        else if (mainBtn) mainBtn.click();
      });
    }
  }

  function goToMedia(root, mediaId) {
    const slide = root.querySelector('[data-media-id="' + mediaId + '"]');
    const track = root.querySelector('.gallery__track');
    if (slide && track) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }

  /* ------------------------------------------------------------
     Slideshow
  ------------------------------------------------------------ */
  function initSlideshow(el) {
    const track = el.querySelector('.slideshow__track');
    const slides = $$('.slide', track);
    if (slides.length < 2) return;
    const dots = $$('.slideshow__dot', el);
    let i = 0, timer;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach((d, j) => { d.classList.toggle('is-active', i === j); d.setAttribute('aria-current', i === j); });
      slides.forEach((s, j) => s.setAttribute('aria-hidden', i !== j));
    };
    const auto = () => {
      clearInterval(timer);
      if (el.dataset.autoplay === 'true') timer = setInterval(() => go(i + 1), Number(el.dataset.speed || 5) * 1000);
    };
    dots.forEach((d, j) => d.addEventListener('click', () => { go(j); auto(); }));
    el.querySelectorAll('[data-slide-nav]').forEach((b) => b.addEventListener('click', () => { go(i + Number(b.dataset.slideNav)); auto(); }));
    let x0 = null;
    el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); auto(); }
      x0 = null;
    });
    el.addEventListener('mouseenter', () => clearInterval(timer));
    el.addEventListener('mouseleave', auto);
    go(0); auto();
  }

  /* Announcement rotator */
  function initRotator(el) {
    const slides = $$('.announcement__slide', el);
    if (slides.length < 2) return;
    let i = 0;
    setInterval(() => {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, Number(el.dataset.speed || 4) * 1000);
  }

  /* ------------------------------------------------------------
     Countdowns: data-countdown="midnight" | "evergreen:<minutes>" | ISO date
  ------------------------------------------------------------ */
  function initCountdown(el) {
    const mode = el.dataset.countdown || 'midnight';
    let end;
    if (mode === 'midnight') {
      end = new Date(); end.setHours(23, 59, 59, 999); end = end.getTime();
    } else if (mode.indexOf('evergreen:') === 0) {
      const key = 'lumora-cd-' + (el.dataset.key || 'x');
      end = Number(store.get(key));
      if (!end || end < Date.now()) { end = Date.now() + Number(mode.split(':')[1]) * 60000; store.set(key, end); }
    } else {
      end = new Date(mode).getTime();
    }
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      const h = Math.floor(left / 3600000), m = Math.floor((left % 3600000) / 60000), s = Math.floor((left % 60000) / 1000);
      el.textContent = (h ? pad(h) + ':' : '') + pad(m) + ':' + pad(s);
    };
    tick(); setInterval(tick, 1000);
  }

  /* Delivery dates: data-delivery-days="N" data-format="short|long" */
  function initDelivery(el) {
    const add = (n) => {
      const d = new Date();
      let added = 0;
      const skipWeekends = el.dataset.skipWeekends === 'true';
      while (added < n) {
        d.setDate(d.getDate() + 1);
        if (!skipWeekends || (d.getDay() !== 0 && d.getDay() !== 6)) added++;
      }
      return d;
    };
    const d = add(Number(el.dataset.deliveryDays || 0));
    el.textContent = d.toLocaleDateString(document.documentElement.lang || undefined, { month: 'short', day: 'numeric' });
  }

  /* Tabs */
  function initTabs(el) {
    const btns = $$('[role="tab"]', el);
    const panels = $$('[role="tabpanel"]', el);
    btns.forEach((b, i) => b.addEventListener('click', () => {
      btns.forEach((x, j) => x.setAttribute('aria-selected', i === j));
      panels.forEach((p, j) => (p.hidden = i !== j));
    }));
  }

  /* Reveal on scroll */
  function initReveal() {
    if (!document.body.classList.contains('has-animations') || !('IntersectionObserver' in window)) {
      $$('.reveal').forEach((e) => e.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -60px 0px' });
    $$('.reveal:not(.is-visible)').forEach((e) => io.observe(e));
  }

  /* Predictive search */
  function initSearch(modal) {
    const input = modal.querySelector('input[type="search"]');
    const out = modal.querySelector('[data-predictive]');
    if (!input || !out || modal.dataset.predictive === 'false') return;
    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        const res = await fetch(window.theme.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search');
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        const r = html.querySelector('#PredictiveResults');
        out.innerHTML = r ? r.innerHTML : '';
      }, 250);
    });
  }

  /* Video: click-to-load */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-video-play]');
    if (!b) return;
    const tpl = b.parentElement.querySelector('template');
    if (tpl) b.parentElement.replaceChildren(tpl.content.cloneNode(true));
  });

  /* Share */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-share]');
    if (!b) return;
    const url = b.dataset.share || window.location.href;
    if (navigator.share) { try { await navigator.share({ url, title: document.title }); } catch (err) {} return; }
    try { await navigator.clipboard.writeText(url); toast(b.dataset.copied || 'Link copied'); } catch (err) {}
  });

  function toast(msg) {
    const t = document.createElement('div');
    t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 2200);
  }

  /* Newsletter popup */
  function initPopup(el) {
    const key = 'lumora-popup-' + el.dataset.id;
    if (store.get(key) || window.Shopify && window.Shopify.designMode) return;
    setTimeout(() => { el.hidden = false; }, Number(el.dataset.delay || 5) * 1000);
    el.addEventListener('click', (e) => {
      if (e.target === el || e.target.closest('[data-popup-close]')) { el.hidden = true; store.set(key, '1'); }
    });
  }

  /* Collection filters: auto-submit */
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-facets]');
    if (!form || e.target.matches('[data-price-input]')) return;
    form.requestSubmit ? form.requestSubmit() : form.submit();
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-sort]')) {
      const u = new URL(window.location.href);
      u.searchParams.set('sort_by', e.target.value);
      window.location.href = u.toString();
    }
  });
  /* Close other dropdowns when one opens */
  document.addEventListener('click', (e) => {
    $$('details[data-dropdown][open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* Localization selects */
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-localization]')) e.target.form.submit();
  });


  /* ------------------------------------------------------------
     Free offer link (?offer=free): shows the product as FREE until expiry
     and applies the store's 100% discount code to the cart.
  ------------------------------------------------------------ */
  const OFFER_KEY = 'lumora_free_offer_products';
  const ls = {
    get() { try { return JSON.parse(localStorage.getItem(OFFER_KEY) || '{}') || {}; } catch (e) { return {}; } },
    set(v) { try { localStorage.setItem(OFFER_KEY, JSON.stringify(v)); } catch (e) {} }
  };
  function activeOffers() {
    const list = ls.get(); const now = Date.now(); let changed = false;
    Object.keys(list).forEach((h) => { if (now > list[h]) { delete list[h]; changed = true; } });
    if (changed) ls.set(list);
    return list;
  }
  function offerEligible(cfg, product) {
    if (!product) return false;
    if (cfg.scope !== 'tagged') return true;
    return (product.tags || []).map((t) => t.toLowerCase()).includes((cfg.tag || '').toLowerCase());
  }
  async function getCart() { const r = await fetch(window.theme.routes.cart + '.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  async function setDiscountCodes(codes) {
    const res = await fetch(window.theme.routes.cart + '/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: CART_SECTIONS, sections_url: window.location.pathname })
    });
    const data = await res.json();
    renderSections(data.sections);
    return data;
  }
  function showFreePrice(cfg) {
    document.documentElement.classList.add('free-offer-active');
    $$('[data-update="price"], [data-update="sticky-price"]').forEach((wrap) => {
      const price = wrap.querySelector('.price');
      if (!price || price.dataset.freeDone) return;
      const cur = price.querySelector('.price__current');
      if (!cur) return;
      let cmp = price.querySelector('.price__compare');
      if (!cmp) { cmp = document.createElement('s'); cmp.className = 'price__compare'; cmp.textContent = cur.textContent; cur.after(cmp); }
      cur.textContent = cfg.priceText || 'FREE';
      price.classList.add('price--on-sale');
      let badge = price.querySelector('.badge');
      if (wrap.dataset.update === 'price') {
        if (!badge) { badge = document.createElement('span'); badge.className = 'badge badge--sale'; price.appendChild(badge); }
        badge.textContent = cfg.badgeText || 'SAVE 100%';
      } else if (badge) badge.remove();
      price.dataset.freeDone = '1';
    });
    $$('.gallery__badge').forEach((b) => { b.textContent = cfg.badgeText || 'SAVE 100%'; });
    const info = $('.product__info');
    if (cfg.banner && info && !$('.free-offer-banner', info)) {
      const el = document.createElement('div');
      el.className = 'free-offer-banner';
      el.textContent = cfg.banner;
      info.prepend(el);
    }
  }
  async function initFreeOffer() {
    const cfg = window.theme.freeOffer;
    if (!cfg || !cfg.code) return;
    const product = window.theme.product;
    const params = new URLSearchParams(window.location.search);
    const offers = activeOffers();
    const code = cfg.code.trim();

    if (product && params.get(cfg.param) === cfg.value && offerEligible(cfg, product)) {
      let until;
      if (cfg.expiry === 'hours') until = Date.now() + Number(cfg.hours || 24) * 3600000;
      else { const m = new Date(); m.setHours(24, 0, 0, 0); until = m.getTime(); }
      offers[product.handle] = until;
      ls.set(offers);
    }

    const unlockedHere = product && offers[product.handle];
    if (unlockedHere) {
      showFreePrice(cfg);
      document.addEventListener('product:updated', () => showFreePrice(cfg));
    }

    try {
      const cart = await getCart();
      const codes = (cart.discount_codes || []).map((d) => d.code);
      const hasCode = codes.some((c) => c.toLowerCase() === code.toLowerCase());
      const anyActive = Object.keys(offers).length > 0;
      if (anyActive && !hasCode) {
        await setDiscountCodes(codes.concat(code));
      } else if (!anyActive && hasCode) {
        // Offer expired or never unlocked on this browser: remove only the promo code, keep any other codes.
        await setDiscountCodes(codes.filter((c) => c.toLowerCase() !== code.toLowerCase()));
      }
    } catch (e) { /* cart unavailable */ }
  }

  /* ------------------------------------------------------------
     Init (also re-run when sections reload in the theme editor)
  ------------------------------------------------------------ */
  function init(scope) {
    const ctx = scope || document;
    $$('[data-product-info]', ctx).forEach(initProduct);
    $$('[data-slideshow]', ctx).forEach(initSlideshow);
    $$('[data-rotator]', ctx).forEach(initRotator);
    $$('[data-countdown]', ctx).forEach(initCountdown);
    $$('[data-delivery-days]', ctx).forEach(initDelivery);
    $$('[data-tabs]', ctx).forEach(initTabs);
    $$('.search-modal', ctx).forEach(initSearch);
    $$('[data-popup]', ctx).forEach(initPopup);
    initCartTimer();
    initReveal();
    if (!scope) { setTimeout(syncDrawerExtras, 300); initFreeOffer(); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('#cart-drawer')) openDrawer('cart-drawer');
  });
})();
